import { lazyLoad } from 'utils/loadable';

export const AdminListPage = lazyLoad(
  () => import('./index'),
  module => module.AdminListPage,
);
